/**
 * StatCard - 통계 카드 컴포넌트
 *
 * 대시보드에서 주요 지표를 아이콘, 값, 트렌드, 설명과 함께 표시한다.
 * @param trend - 증감 표시 ({ value, direction: 'up' | 'down' })
 * @param footerLink - 하단 상세보기 링크
 */
'use client';

import React from 'react';
import Link from 'next/link';
import { TrendingUp, TrendingDown, ChevronRight } from 'lucide-react';
import styles from './StatCard.module.css';

export interface StatCardProps {
  icon: React.ReactNode;
  iconVariant: 'purple' | 'brand' | 'green' | 'orange';
  label: string;
  value: string | number;
  trend?: { value: string; direction: 'up' | 'down' };
  description?: string;
  footerLink?: { label: string; href: string };
}

export default function StatCard({
  icon,
  iconVariant,
  label,
  value,
  trend,
  description,
  footerLink,
}: StatCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardTop}>
        <div
          className={`${styles.iconWrap} ${styles[iconVariant === 'brand' ? 'purple' : iconVariant]}`}
        >
          {icon}
        </div>
        <div className={styles.content}>
          <span className={styles.label}>{label}</span>
          <div className={styles.valueRow}>
            <span className={styles.value}>{value}</span>
            {trend && (
              <span
                className={`${styles.trend} ${
                  trend.direction === 'up' ? styles.trendUp : styles.trendDown
                }`}
              >
                {trend.direction === 'up' ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
                {trend.value}
              </span>
            )}
          </div>
        </div>
      </div>
      {description && <p className={styles.description}>{description}</p>}
      {footerLink && (
        <div className={styles.footer}>
          <Link href={footerLink.href} className={styles.footerLink}>
            {footerLink.label}
            <ChevronRight size={14} />
          </Link>
        </div>
      )}
    </div>
  );
}
